import { Route, Routes, Outlet, Navigate } from 'react-router-dom';
import {AzPageHeader} from '../../components/AzPageHeader'
import { OptionListWrapper } from './options-list/OptionList';
import { useIntl } from 'react-intl';

const OptionPage = () => {
  const intl = useIntl();

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='options'
          element={
            <>
              <AzPageHeader title={intl.formatMessage({ id: 'OPTION_PAGE.TITLE' })} />
              <OptionListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/Option-management/options' />} />
    </Routes>
  );
};

export default OptionPage;